import React, { useEffect } from 'react';
import { StyledCart, StyledCartWrapper } from './style';
import { FarmProduct } from 'public/context/CartContext';
import GroupedFarmCart from '../GroupedFarmCart/GroupedFarmCart';
import CartSummary from '../CartSummary/CartSummary';
import { useIntl } from 'react-intl';
import CartStep from 'enums/cart-step';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useMarketType from '../../../../utils/useMarketType';
import PublicRoute from 'enums/publicRoutes';
import { FormInstance } from 'antd';

interface CartProps {
  farmProducts: FarmProduct[];
  setCurrent?: React.Dispatch<React.SetStateAction<CartStep>>;
  current: CartStep;
  isView?: boolean | undefined;
  priceTotal: number;
  form?: FormInstance;
}

const Cart = ({
  farmProducts,
  setCurrent,
  current,
  isView,
  priceTotal,
  form,
}: CartProps) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { isEmarket } = useMarketType();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const status = searchParams.get('status');
    if (status === 'pending' || status === 'success') {
      return;
    }

    if (farmProducts.length === 0) {
      navigate(isEmarket ? '/' : PublicRoute.WHOLESALE_PRODUCTS_ALL, {
        replace: true,
      });
    }
  }, [farmProducts, navigate, searchParams]);

  return (
    <StyledCartWrapper>
      <div className={'cart-page-title mobile'}>
        <h1>
          {isView
            ? intl.formatMessage({ id: 'cart.your_order_received_title' })
            : intl.formatMessage({ id: 'general.basket' })}
        </h1>
      </div>
      <StyledCart isView={isView}>
        <GroupedFarmCart farmProducts={farmProducts} isView={isView} />
        <CartSummary
          priceTotal={priceTotal}
          farmProducts={farmProducts}
          setCurrent={setCurrent}
          current={current}
          isView={isView}
          form={form}
        />
      </StyledCart>
    </StyledCartWrapper>
  );
};

export default Cart;
